import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function usePackagingPOBackHref() {
    const location = useLocation();

    const purchaseOrdersFilters = useMemo(() => {
        const locationState = location.state ?? {};

        if (
            typeof locationState.packagingPurchaseOrdersFilters === 'string' &&
            locationState.packagingPurchaseOrdersFilters.length > 0
        ) {
            return locationState.packagingPurchaseOrdersFilters;
        }

        if (typeof locationState.purchaseOrdersFilters === 'string' && locationState.purchaseOrdersFilters.length > 0) {
            return locationState.purchaseOrdersFilters;
        }

        if (typeof location?.search === 'string' && location.search) {
            return location.search;
        }

        if (typeof window !== 'undefined' && window?.location?.search) {
            return window.location.search;
        }

        return '';
    }, [location.search, location.state]);

    return useMemo(() => {
        if (!purchaseOrdersFilters) {
            return '/packaging/viewPurchaseOrder-v2';
        }

        return {
            pathname: '/packaging/viewPurchaseOrder-v2',
            search: purchaseOrdersFilters,
        };
    }, [purchaseOrdersFilters]);
}
